module.exports = __webpack_public_path__ + "static/landing-c077bda05220e7a884809429d77b9a35.png";